"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
function Down(props) {
    return (react_1.default.createElement("svg", tslib_1.__assign({ width: "1em", height: "1em", viewBox: "0 0 16 16" }, props),
        react_1.default.createElement("polygon", { fill: "currentColor", points: "5.372 2.416 5.372 9.416 12.372 9.416 12.372 11.416 3.372 11.416 3.372 2.416", transform: "rotate(-45 6.665 6.416)" })));
}
exports.default = Down;
//# sourceMappingURL=Down.js.map